import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { FormSpy } from 'react-final-form';
import Field from '../forms/Field';
import FormGroupInline from '../forms/FormGroupInline';
import translate from '../i18n/translate/translate';
import Form from '../forms/Form/Form';
import Button from '../controls/Button/Button';
import RenderPropsProvider from '../forms/RenderPropsProvider';
import { ButtonColor } from '../controls/Button/ButtonColor';
/**
 * Component renders form fields for PromotionPerformance detail report page
 */

var QuerryForm =
/*#__PURE__*/
function (_React$Component) {
  _inherits(QuerryForm, _React$Component);

  function QuerryForm(props) {
    _classCallCheck(this, QuerryForm);

    return _possibleConstructorReturn(this, _getPrototypeOf(QuerryForm).call(this, props));
  }

  _createClass(QuerryForm, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement(Form, {
        descriptions: this.props.store.getFormDescriptions,
        initialValues: this.props.store.getInitialValues,
        onSubmit: this.props.submitHandler
      }, React.createElement(FormSpy, {
        subscription: {
          values: true
        }
      }, function (_ref) {
        var values = _ref.values;
        return React.createElement(RenderPropsProvider, {
          component: function component(_ref2) {
            var form = _ref2.form;
            return React.createElement(FormGroupInline, null, React.createElement(Field, {
              name: "limit"
            }), React.createElement(Field, {
              name: "offset"
            }), React.createElement(Button, {
              type: "button",
              buttonColor: ButtonColor.Outline,
              onClick: function onClick() {
                return _this.props.submitHandler(values);
              }
            }, translate('PromotionPerformance_reset_report')));
          }
        });
      }));
    }
  }]);

  return QuerryForm;
}(React.Component);

export default QuerryForm;